import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "autoClearSearchValue"];

/**
 * @file useCreateSelect
 */
import { useCallback, useEffect } from 'react';
import { useRefCallback, useRefGetter, useSingleton, useUpdate } from '@tencent/glue-react-use';
import { Select } from '@tencent/glue-model-select';
export function useSelect(options) {
  var onChange = options.onChange,
      _options$autoClearSea = options.autoClearSearchValue,
      autoClearSearchValue = _options$autoClearSea === void 0 ? false : _options$autoClearSea,
      extra = _objectWithoutProperties(options, _excluded);

  var select = useSingleton(function () {
    return new Select(extra);
  });
  var onChangeCallback = useRefCallback(onChange);
  var autoClearSearchValueGetter = useRefGetter(autoClearSearchValue);
  var update = useUpdate();
  select.updateSelectOptions(extra);
  var handleChange = useCallback(function (value, info) {
    onChangeCallback(value, info);

    if (autoClearSearchValueGetter()) {
      select.setQuery('');
    }
  }, []);
  useEffect(function () {
    select.addListener('value-change', handleChange);
    select.addListener('select-label-update', update);
    return function () {
      select.removeListener('value-change', handleChange);
      select.removeListener('select-label-update', update);
      select.dispose();
    };
  }, []);
  useEffect(function () {
    select.commit();
  });
  return select;
}